<template>
    <div class="e-line">
        <div ref="eline" class="e-line__box"></div>
    </div>
</template>

<script>
export default {
    props: {
        colors: {
            type: Array,
            default: () => [
                "rgba(254,106,172,1)", // 0% 处的颜色
                "rgba(254,106,172,0)", // 100% 处的颜色
            ],
        },
        // Number[]
        rows: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            option: {
                color: [this.colors[0]],
                yAxis: {
                    type: 'value',
                    show: false,
                },
                xAxis: {
                    type: 'category',
                    data: this.rows.map((item) => 'a' + item),
                    show: false,
                },
                legend: {
                    show: false,
                },
                series: [{
                    symbol: 'none',
                    smooth: true,
                    data: this.rows.map((item) => item),
                    type: 'line',
                    area: true, //是否显示为面积图
                    lineStyle: {
                        color: this.colors[0]
                    },
                    areaStyle: {
                        //面积图颜色设置
                        color: {
                            type: "linear",
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 0.6,
                            colorStops: this.colors.map((item, i) => ({
                                offset: i,
                                color: item, // 100% 处的颜色
                            })),
                            globalCoord: false, // 缺省为 false
                        },
                    },
                }]
            }
        };
    },
    computed: {
        chartData() {
            return {
                //数据
                columns: ["label", "value"],
                rows: this.rows.map((item, i) => ({
                    label: 'A' + i,
                    value: item,
                })),
            }
        }
    },
    mounted() {
        this.load()
    },
    methods: {
        async load() {
            await this.$nextTick()
            const lineChart = echarts.init(this.$refs.eline);
            lineChart.setOption(this.option)
        }
    },
};
</script>
<style lang="scss" scoped>
.e-line {
    height: 100px;
    &__box {
        width: 100%;
        height: 100%;
    }
}
</style>
